import {
  ArticlesSearchByParams,
  ArticlesSortByParams,
  ARTICLES_ITEMS_PER_PAGE
} from '../../../../../constants';
import { APICallInterface } from 'app/scripts/services/sagas/types';

interface IFetchArticlesList {
  currentPage: number;
  searchBy: ArticlesSearchByParams;
  searchValue: string;
  appliedFilterTags: string[];
  sortBy: ArticlesSortByParams;
}

export const fetchArticlesListApiCall = ({
  currentPage,
  searchBy,
  searchValue,
  appliedFilterTags,
  sortBy
}: IFetchArticlesList): APICallInterface => ({
  types: ['FETCH_ARTICLES_REQUEST', 'FETCH_ARTICLES_SUCCESS', 'FETCH_ARTICLES_FAILURE'],
  params: {
    method: 'GET',
    url: '/host-panel/mba/articles',
    queryParams: {
      count: ARTICLES_ITEMS_PER_PAGE,
      offset: ARTICLES_ITEMS_PER_PAGE * currentPage,
      tags: appliedFilterTags,
      sortBy,
      [searchBy]: searchValue
    }
  }
});
